import type cytoscape from 'cytoscape'

import type { Feature } from '../../feature'
import * as models from '../../models'

/**
 * Applies appropriate classes to style each node appropriately
 */
export function setupNodeClasses(
  cy: cytoscape.Core,
  params: setupNodeClasses.AdditionalParams,
) {
  // Initializes classes
  cy.nodes().forEach(node => _applyAppropriateClasses(node, params))
  // Handles additions/edits
  const _handleNodeChange: cytoscape.EventHandler = event => {
    const newNode = event.target as cytoscape.NodeSingular
    _applyAppropriateClasses(newNode, params)
  }
  cy.on('add', 'node', _handleNodeChange)
  cy.on('data', 'node', _handleNodeChange)
}
export namespace setupNodeClasses {
  export interface AdditionalParams extends models.OrgChart.Identifier {
    readonly feature: Feature
  }
}

/**
 * Used by {@link setupNodeClasses} to apply the appropriate classes to a
 * specific node based on the attributes of that node
 */
function _applyAppropriateClasses(
  node: cytoscape.NodeSingular,
  { feature, orgChartId }: setupNodeClasses.AdditionalParams,
): void {
  // Type class
  const typeClass = (node.data('type') as unknown)?.toString()
  if (typeClass) {
    // Removes existing type classes
    node.removeClass(models.Node.TYPES.map(type => type.value))
    // Adds new one
    node.addClass(typeClass)
  }
  // Changed class
  if (
    orgChartId === 'proposed' &&
    feature.selectors.hasProposedChange({ nodeId: node.id() }).asSignal()
  ) {
    node.addClass('changed')
  } else if (node.hasClass('changed')) {
    node.removeClass('changed')
  }
}
